module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/window/texture.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/window/texture.png
// module id = 506
// module chunks = 0